// src/pages/CalculoHonorarios/components/SecaoResultado.js

import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import rehypeStringify from 'rehype-stringify';
import rehypeSanitize from 'rehype-sanitize';

/**
 * Converte Markdown -> HTML (seguro) pra colar no Outlook mantendo formatação
 */
async function markdownToHtml(markdown) {
  const file = await unified()
    .use(remarkParse)
    .use(remarkGfm)
    .use(remarkRehype)
    .use(rehypeSanitize) // evita HTML malicioso vindo do conteúdo
    .use(rehypeStringify)
    .process(markdown);

  return String(file);
}

/**
 * Componente reutilizável para exibir resultados (Cálculo, Racional, Email)
 * com suporte a Markdown e copiar para área de transferência
 */
const SecaoResultado = ({ titulo, conteudo, icone = '📄', colapsavel = true }) => {
  const [colapsado, setColapsado] = useState(false);
  const [copiado, setCopiado] = useState(false);

  const copiarParaAreaTransferencia = async () => {
    try {
      // Gera HTML a partir do markdown
      const htmlBody = await markdownToHtml(conteudo);

      // Embrulha em documento HTML (alguns clientes colam melhor assim)
      const html = `<!doctype html><html><body>${htmlBody}</body></html>`;

      // Se o browser suportar clipboard rico (HTML + texto), usa isso
      if (navigator.clipboard?.write && window.ClipboardItem) {
        const item = new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([conteudo], { type: 'text/plain' }),
        });

        await navigator.clipboard.write([item]);
      } else {
        // Fallback (sem formatação)
        await navigator.clipboard.writeText(conteudo);
      }

      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch (err) {
      console.error('Erro ao copiar:', err);
      alert('Erro ao copiar para área de transferência');
    }
  };

  if (!conteudo) return null;

  return (
    <div className="secao-resultado">
      <div className="secao-resultado-header">
        <h3
          onClick={() => colapsavel && setColapsado(!colapsado)}
          style={{ cursor: colapsavel ? 'pointer' : 'default' }}
        >
          {colapsavel && <span className="collapse-icon">{colapsado ? '▶' : '▼'}</span>}
          <span>{icone}</span>
          <span>{titulo}</span>
        </h3>

        {!colapsado && (
          <button
            className="btn-copiar"
            onClick={copiarParaAreaTransferencia}
            title="Copiar para área de transferência"
          >
            {copiado ? '✅ Copiado' : '📋 Copiar'}
          </button>
        )}
      </div>

      {!colapsado && (
        <div className="secao-resultado-conteudo">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{conteudo}</ReactMarkdown>
        </div>
      )}
    </div>
  );
};

export default SecaoResultado;